import { BookingType } from '../types/types';

export function getBookingType(
    products: any[],
    isPackageOrStylingOrder: boolean,
    isCustomerAllowedToBook: boolean
): BookingType {
    const selectedProducts = products.filter((x: any) => x.available && x.selected);

    if (selectedProducts.length <= 0) {
        return BookingType.NonBookableOrder;
    }

    const hasNoForbiddenBookingProductProperties = selectedProducts.every(
        (x: any) =>
            !x.hasProductPropertyEditCustomerImages &&
            !x.hasProductPropertyOnlyCentralBooking &&
            !x.hasProductPropertySunsetPhotography
    );

    const someSelectedProductsAreBookableOnlyByAdmins = selectedProducts.some(
        (x: any) => x.bookingCondition.value === 3 /* BookableByAdmin */
    );
    const allSelectedProductsAreNotBookable = selectedProducts.every(
        (x: any) => x.bookingCondition.value === 4 /* NotBookable */
    );

    const isCustomerBookableOrder = 
        !!isCustomerAllowedToBook &&
        hasNoForbiddenBookingProductProperties &&
        !someSelectedProductsAreBookableOnlyByAdmins &&
        !allSelectedProductsAreNotBookable;

    if (isCustomerBookableOrder) {
        return BookingType.CustomerBookableOrder;
    }

    if (allSelectedProductsAreNotBookable) {
        return BookingType.NonBookableOrder;
    }

    return BookingType.AdminBookableOrder;
}

